
import { Game } from './game';

function main(): void {
  new Game();
}

main();
